<div class="container-tab-lists new-table-style">

  <div class="inner-tcontainer-tab">
    <div class="header-container">
      <div class="header-left">
        <h2>
          @if (defaults.getManagementNameParts(); as parts) {
            Actual {{isBranchReporting() ? 'Branch Reporting ' : 'Reporting '}}({{parts.prefix}}@for (gf of parts.gfParts; track gf; let i = $index) {
            @if (i > 0) {
              <span> / </span>
              }<span [class.gf-selected]="gf === parts.selectedGF">{{gf}}</span>
              } - {{defaults.fiscalYear - 1}}/{{defaults.fiscalYear}} - Period {{defaults.period}})
            } @else {
              {{title}}
            }
            {{isAllLoaded === false && !hideSections() ? waitHeader : ''}}
          </h2>
        </div>
        <div class="header-right">
          <h2>{{reportingDeadlineBanner}}</h2>
        </div>
      </div>
      <div style="display:flow-root">
        @if (!hideSections()) {
          <div style="float:left; width:40vw">
            <app-filter
              [separatorKeysCodes]="separatorKeysCodes"
              [addOnBlur]="addOnBlur"
              [disabled]="isAllLoaded === false"
              [searchItems]="searchItems"
              [selectable]="selectable"
              [removable]="removable"
              [isShowAllEnabled]="isShowAllEnabled"
              (filterChange)="filter = $event"
            ></app-filter>
          </div>
        }
        <div style="text-align:right; float:right">

          @if (isEditModeEnabled && !isExcelModeEnabled) {
            <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave()">
              <span class='glyphicon glyphicon-floppy-disk'></span> Save
            </a>
          }

          @if (defaults.userCanReleaseMersy() && hideSections()) {
            <a class='kpi-button-menu' title="Release Mode" (click)="onClickReleaseMode()">
              {{'Release All'}}
            </a>
          }

          @if (!isEditModeEnabled && defaults.userCanReleaseMersy() && !hideSections()) {
            <a class='kpi-button-menu' title="Release Mode" (click)="toggleRelease();isRevokeActive ? toggleRevoke():null">
              {{releaseButtonText}}
            </a>
          }

          @if (defaults.userCanRevokeMersy() && hideSections()) {
            <a class='kpi-button-menu' title="Revoke all released values" (click)="onClickRevoke()">
              {{'Revoke All'}}
            </a>
          }

          @if (!isEditModeEnabled && showReleaseLabel && defaults.userCanRevokeMersy() && !hideSections()) {
            <a class='kpi-button-menu' title="Revoke all released values" (click)="toggleRevoke();isReleaseActive ? toggleRelease():null ">
              {{revokeButtonText}}
            </a>
          }

          @if (!isExcelModeEnabled && !isEditModeEnabled && !isApprovalModeEnabled && defaults.userCanEditMersy()) {
            <a class='kpi-button-menu' title="Excel" (click)="onClickExcelButton()">
              Excel
            </a>
          }

          @if (defaults.userCanEditMersy()) {
            <a class='kpi-button-menu' title="Download OPL previous year" (click)="downloadOplInformationFromLastYear()">
              <span class='glyphicon glyphicon-download'></span> Download Monthly OPL Previous Year
            </a>
          }

          @if (isExcelModeEnabled) {
            <a class='kpi-button-menu' title="Download" (click)="downloadExcelInformation()">
              <span class='glyphicon glyphicon-download'></span> Download
            </a>
          }

          @if (isExcelModeEnabled && defaults.userCanEditMersy()) {
            <a class='kpi-button-menu' title="Upload" (click)="goUploadFileView()">
              <span class='glyphicon glyphicon-upload'></span> Upload
            </a>
          }

          @if (isExcelModeEnabled) {
            <a class='kpi-button-menu' title="Cancel" (click)="onClickCancelButton()">
              {{'Exit Excel mode'}}
            </a>
          }

          @if (!isApprovalModeEnabled && !isExcelModeEnabled && !hideSections() && defaults.userCanEditMersy()) {
            <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
              <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
            </a>
          }

          @if (isShowAllEnabled === false && !hideSections()) {
            <a class='kpi-button-menu' title="Show All" (click)="onClickShowAllButton()">
              <span class='glyphicon glyphicon-eye-open'></span> Show All
            </a>
          }

          @if (isShowAllEnabled === true && !hideSections()) {
            <a class='kpi-button-menu' title="Hide empty" (click)="onClickShowAllButton()">
              <span class='glyphicon glyphicon-eye-close'></span> Hide empty
            </a>
          }

          @if (!hideSections()) {
            <h5>
              @if (isShowAllEnabled === true) {
                <span>Showing all available entries </span>
              }
              @if (isShowAllEnabled === false) {
                <span>Excluding empty values </span>
              }
              @if (showReleaseLabel === true || isEditModeEnabled === true) {
                <span> / </span>
              }
              @if (isEditModeEnabled === true) {
                <span class="salmon-color">Editable kpi values</span>
              }
              @if (showReleaseLabel === true && isEditModeEnabled === true) {
                <span>/</span>
              }
              @if (showReleaseLabel === true) {
                <span class="green-release-color">Released kpi values </span>
              }
            </h5>
          }

          @if (!hideSections) {
            <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
              Edit Mode is enabled. Please click on Save button to save all changes
            </h5>
          }
        </div>
      </div>
      <br />

      @if (!hideSections()) {
        <actualreporting-list [list]="list"
          [isEditModeEnabled]="isEditModeEnabled"
          [filter]="filter"
          [isReleaseModeEnabled]="isApprovalModeEnabled"
          [auxFilterPredicate]="auxFilterPredicate"
          [isShowAllEnabled]="isShowAllEnabled"
          [isReleaseActive]="isReleaseActive && !isEditModeEnabled"
          [isRevokeActive]="isRevokeActive && !isEditModeEnabled"
          (onClickRevokeMode)="onClickRevoke()"
          (onClickReleaseMode)="onClickReleaseMode()"
        ></actualreporting-list>
      }
    </div>
  </div>